/* Road Carpet UI motion v1.1
   - word-by-word masked heading reveals
   - staggered reveals for cards / media across the whole theme
   - clip-path image reveals, magnetic buttons, cursor spotlight on dark sections
   - floating help button */
(function () {
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var finePointer = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  var design = document.documentElement.classList.contains('shopify-design-mode');

  var io = ('IntersectionObserver' in window) ? new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (!e.isIntersecting) return;
      e.target.classList.add('is-in');
      io.unobserve(e.target);
    });
  }, { rootMargin: '0px 0px -10% 0px', threshold: 0.12 }) : null;

  function watch(el) {
    if (!io || reduced || design) { el.classList.add('is-in'); return; }
    io.observe(el);
  }
  function belowFold(el) { return el.getBoundingClientRect().top > window.innerHeight * 0.92; }

  // 1) split headings into masked words
  function split(root) {
    var sel = '.rc-sec__title, .rc-split, main .shopify-section:not(.rc-hero-section) :is(h2, .h2)';
    (root || document).querySelectorAll(sel).forEach(function (h) {
      if (h.dataset.rcSplit || h.closest('.rc-hero, .rc-faq__item, [dir="rtl"]') || !h.textContent.trim()) return;
      if (!belowFold(h)) { h.dataset.rcSplit = 'skip'; return; }
      h.dataset.rcSplit = '1';
      var i = 0;
      (function walk(node) {
        Array.prototype.slice.call(node.childNodes).forEach(function (n) {
          if (n.nodeType === 3) {
            var frag = document.createDocumentFragment();
            n.textContent.split(/(\s+)/).forEach(function (w) {
              if (!w) return;
              if (/^\s+$/.test(w)) { frag.appendChild(document.createTextNode(w)); return; }
              var m = document.createElement('span'); m.className = 'rc-w';
              var inner = document.createElement('span'); inner.textContent = w; inner.style.setProperty('--wi', i++);
              m.appendChild(inner); frag.appendChild(m);
            });
            n.parentNode.replaceChild(frag, n);
          } else if (n.nodeType === 1 && !/^(BR|SVG|IMG)$/.test(n.tagName)) walk(n);
        });
      })(h);
      h.classList.add('rc-words');
      watch(h);
    });
  }

  // 2) staggered reveals for content across the theme
  function auto(root) {
    var sel = [
      '.rc-io',
      'main .product-card', 'main .collection-card', 'main .resource-card',
      'main .shopify-section:not(.rc-hero-section) .media-block', 'main .shopify-section:not(.rc-hero-section) .text-block',
      'main .accordion', 'main .rc-cat__media'
    ].join(',');
    var groups = new Map();
    (root || document).querySelectorAll(sel).forEach(function (el) {
      if (el.dataset.rcAuto) return;
      el.dataset.rcAuto = '1';
      if (!el.classList.contains('rc-io')) {
        if (!belowFold(el)) return;
        el.classList.add('rc-io');
      }
      var p = el.parentElement; var n = groups.get(p) || 0; groups.set(p, n + 1);
      if (!el.style.getPropertyValue('--d')) el.style.setProperty('--d', Math.min(n, 6) * 70 + 'ms');
      watch(el);
    });
  }

  // 3) magnetic buttons
  function magnetic(root) {
    if (!finePointer || reduced) return;
    (root || document).querySelectorAll('.rc-btn, .rc-help__btn').forEach(function (b) {
      if (b.dataset.rcMag) return; b.dataset.rcMag = '1';
      b.addEventListener('pointermove', function (e) {
        var r = b.getBoundingClientRect();
        var x = (e.clientX - r.left - r.width / 2) / r.width, y = (e.clientY - r.top - r.height / 2) / r.height;
        b.style.transform = 'translate(' + (x * 8).toFixed(1) + 'px,' + (y * 6).toFixed(1) + 'px)';
      });
      b.addEventListener('pointerleave', function () { b.style.transform = ''; });
    });
  }

  // 4) cursor spotlight on dark sections
  function spotlight(root) {
    if (!finePointer || reduced) return;
    (root || document).querySelectorAll('.rc-sec:not(.rc-sec--bone), .rc-foot').forEach(function (s) {
      if (s.dataset.rcSpot) return; s.dataset.rcSpot = '1';
      s.classList.add('rc-spot');
      s.addEventListener('pointermove', function (e) {
        var r = s.getBoundingClientRect();
        s.style.setProperty('--mx', (e.clientX - r.left) + 'px');
        s.style.setProperty('--my', (e.clientY - r.top) + 'px');
      });
    });
  }

  // 5) header state
  function header() {
    var last = 0;
    window.addEventListener('scroll', function () {
      var y = window.scrollY;
      document.documentElement.classList.toggle('rc-scrolled', y > 40);
      last = y;
    }, { passive: true });
  }

  // 6) floating help button
  function helpButton() {
    var fab = document.querySelector('[data-rc-help]');
    if (!fab || fab.dataset.ready) return;
    fab.dataset.ready = '1';
    var toggle = fab.querySelector('[data-rc-help-toggle]');
    var panel = fab.querySelector('[data-rc-help-panel]');
    function set(open) {
      fab.classList.toggle('is-open', open);
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      panel.hidden = !open;
    }
    toggle.addEventListener('click', function () { set(!fab.classList.contains('is-open')); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') set(false); });
    document.addEventListener('click', function (e) { if (!fab.contains(e.target)) set(false); });
    var shown = false;
    function show() { if (!shown) { shown = true; fab.classList.add('is-visible'); } }
    window.addEventListener('scroll', function () { if (window.scrollY > 240) show(); }, { passive: true });
    setTimeout(show, 8000);
  }

  function run(root) { split(root); auto(root); magnetic(root); spotlight(root); }
  function init() {
    run();
    header();
    helpButton();
    // late content (recommendations, quick add, infinite collections)
    if ('MutationObserver' in window) {
      var t;
      new MutationObserver(function () { clearTimeout(t); t = setTimeout(function () { run(); }, 120); })
        .observe(document.querySelector('main') || document.body, { childList: true, subtree: true });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', function (e) { run(e.target); });
})();
